import './faq.scss';

/**
 * version    1.0
 * class      <type> (faq)
 * classdesc  Component that manage the page two colums
 */
export class Faq {}
